import {DefaultInformationProps, DefaultNavLinkProps, DefaultNavTextFieldProps} from "@models/DefaultProps.ts";
import {IProduto} from "@models/produtos/produto.ts";
import {Grid, TableCell, TableRow} from "@mui/material";
import {NavigationLink, NavigationLinkProps} from '@shared/custom/NavigationLink.tsx';
import {TextFieldNav} from '@shared/custom/TextFieldNav.tsx';
import React from "react";

export interface ProdutoInformacaoProps extends DefaultInformationProps<IProduto> {
    variant: 'list' | 'grid' | 'row' | 'navigationLink' | 'textfield';
}

export const ProdutoInformacao: React.FC<ProdutoInformacaoProps> = (props) => {
    const {variant} = props;

    if (variant === 'list') return <ProdutoInformacaoList {...props} />;
    if (variant === 'row') return <ProdutoInformacaoRow {...props} />;
    if (variant === 'navigationLink') return <ProdutoInformacaoNavLink {...props} />;

    return <></>;
};

export const ProdutoInformacaoList: React.FC<Omit<ProdutoInformacaoProps, 'variant' | 'overrides'>> = (props) => {
    const {value, EndComponent} = props;

    return (
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid>
                <ProdutoInformacaoNavLink displayMode={'id'} {...props}/>
            </Grid>
            <Grid container justifyContent={'flex-end'}>
                {EndComponent && <EndComponent {...value} />}
            </Grid>
        </Grid>
    );
};

export const ProdutoInformacaoRow: React.FC<Omit<ProdutoInformacaoProps, 'variant' | 'overrides'>> = (props) => {
    const {value, EndComponent} = props;

    return (
        <TableRow>
            <TableCell>{value.id}</TableCell>
            <TableCell>{value.erpId}</TableCell>
            <TableCell>{value.erpFamiliaId}</TableCell>
            <TableCell><ProdutoInformacaoNavLink displayMode={'nome'}
                                                 slotProps={{
                                                     chip: {tableMode: true},
                                                 }}
                                                 {...props}/></TableCell>
            <TableCell align={'right'}>{EndComponent && <EndComponent {...value}/>}</TableCell>
        </TableRow>
    );
};

export const ProdutoInformacaoNavLink: React.FC<Omit<ProdutoInformacaoProps, 'variant' | 'overrides'> & DefaultNavLinkProps<IProduto, keyof IProduto>> = (props) => {
    const {value, slotProps} = props;

    const navLinkProps: NavigationLinkProps = {
        pathName: '/produtos/detalhes',
        searchData: {produtoId: value.id.toString()},
        chipSx: slotProps?.chip?.sx,
        tableMode: slotProps?.chip?.tableMode,
        permissoesNecessarias: ['VisualizarProdutos'],
        value: props.value,
        displayMode: props.displayMode ?? 'nome',
        onClick: () => props.onClick && props.onClick(value),
    };

    return <NavigationLink {...navLinkProps}/>;
};

export const ProdutoInformacaoTextFieldNav: React.FC<Omit<ProdutoInformacaoProps, 'variant' | 'overrides'> & DefaultNavTextFieldProps<IProduto, keyof IProduto, keyof IProduto>> = (props) => {
    const {value} = props;

    const navLinkProps: DefaultNavTextFieldProps<IProduto, 'nome', 'descricao'> = {
        pathName: '/produtos/detalhes',
        searchData: {produtoId: value.id.toString()},
        label: 'Produto',
        onClick: () => props.onClick && props.onClick(value),
    };

    return (
        <TextFieldNav {...navLinkProps}/>
    );
};